import React, { useEffect, useState } from 'react'
import aiImg from '../../../assets/images/ai-avatar.svg'
import onboardingService from '../../../services/onboardingService'
import { StyledMessage } from './NewOnboarding.styles'

const CampaignReady = ({ status, error, onLaunch, onSaveDraft, onConnectLinkedin }) => {
  const busy = status === 'working'
  const [linkedinConnected, setLinkedinConnected] = useState(null)

  useEffect(() => {
    let active = true
    onboardingService
      .getConnectedLinkedinProfiles()
      .then(res => {
        console.log("ffff",res.data)
        if (active) setLinkedinConnected((res?.data || []).some(profile => profile.gologinProfileId && profile.isLoggedIn === true ))
      })
      .catch(() => {
        if (active) setLinkedinConnected(false)
      })
    return () => {
      active = false
    }
  }, [])

  const needsLinkedin = linkedinConnected === false || status === 'needsLinkedin'
  const canLaunch = linkedinConnected === true && status !== 'needsLinkedin'

  const saveDraftButton = (
    <button type='button' onClick={onSaveDraft} disabled={busy}>
      💾 Save As Draft
    </button>
  )

  return (
    <StyledMessage>
      <div className='img-holder'>
        <img src={aiImg} alt='aiImg' />
      </div>
      <div className='content'>
        <div className='text-holder'>
          <span className='text'>
            Everything is ready.<br/><br/>

Your first campaign can now go live.
          </span>
        </div>

        {needsLinkedin && (
          <div className='text-holder'>
            <span className='text'>
              Connect a LinkedIn account to launch. You can still save the campaign as a draft without one.
            </span>
          </div>
        )}

        {status === 'error' && error && (
          <div className='text-holder'>
            <span className='text'>{error}</span>
          </div>
        )}

        <div className='btn-holder'>
          <button type='button' onClick={onLaunch} disabled={busy || !canLaunch}>
            {busy ? 'Working…' : '🚀 Launch Campaign'}
          </button>
          {needsLinkedin && (
            <button type='button' onClick={onConnectLinkedin}>
              Connect LinkedIn
            </button>
          )}
          {saveDraftButton}
        </div>
      </div>
    </StyledMessage>
  )
}

export default CampaignReady
